import axios from 'axios'

/**
 * @param { String } url req url starting with /
 * @param { String } method HTTP method
 * @param { RequestConfig } config request configuration
 * @param { Object } params={ } request params
 *
 * @returns { Promise<Object> } reponse object
**/
export default function logRequestError ()
{
	if (navigator.onLine !== false && window.__req_err_json)
	{
		axios.post('/logs/client-request', { error: window.__req_err_json }, { })
		.catch(e => void 0)
		.then(e => void 0);
	}

	delete window.__req_err_json;
}